/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  message,
  Modal,
  Popover,
  Radio,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "@/common.css";
import {
  CaretDownOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  OneToOneOutlined,
  PlusOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import MainTable from "./component/MainTable";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { Link } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/type";

export default function UserList() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [delList, setDelList] = useState([]);
  const [filtersData, setFiltersData] = useState([]);
  const childRef = useRef(); // 创建一个 ref 来引用子组件实例

  // 定义父组件方法，用于更新父组件的状态

  const deleteNum = (num) => {
    console.log(num);
    setDelList(num);
  };
  //调用子组件showModal方法
  const showModal = () => {
    if (childRef.current) {
      // childRef.current.showModal();
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };

  //删除
  const confirm = () => {
    console.log(delList);
    if (delList.length) {
      Modal.confirm({
        title: "Delete Reminder",
        icon: <ExclamationCircleOutlined />,
        content: "Are you sure you want to delete the selected data?",
        okText: "Sure",
        cancelText: "Cancel",
        onOk: async() => {
          const ids = delList.map(item => item.id)
          //确认删除
          const response = await http.get(
            `${api.MaintenanceDel}?ids=${ids}&userId=${localStorage.getItem(
              "accountId"
            )}`
          )
          if(response?.code === '1'){
            message.success("Successfully Deleted");
            setDelList([]);
            if (childRef.current) {
              childRef.current.newListFun();
            }
          } else {
            message.error(response?.msg || "Failed Deleted");
          }
        },
        onCancel() {
          console.log("Cancel");
        },
        style: {
          top: "40%",
        },
      });
    } else {
      message.warning("Please select the data to delete first."); //请先选择要删除的数据
    }
  };
  // 下载

  const toEcexl = () => {
    Modal.confirm({
      title:
        "You are exporting Data based on Completed DateRange. Are you sure you want to download the data?",
      icon: <ExclamationCircleOutlined />,

      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        try {
          console.log("ecxcl:");
          console.log("filters>>>>>", filtersData);
          const params = { ...filtersData,
            type:filtersData.status
           };
          const response = await http.get(`${api.MaintenanceToExcel}`, {
            responseType: "blob",
            params,
          });
          if (response instanceof Blob) {
            const url = window.URL.createObjectURL(response);

            const link = document.createElement("a");
            link.href = url;

            // 获取当前日期并格式化为 MM-dd-yyyy
            const today = new Date();
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const day = String(today.getDate()).padStart(2, "0");
            const year = today.getFullYear();
            const formattedDate = `${month}-${day}-${year}`;

            const filename = `Maintenance_${formattedDate}.xlsx`;
            link.setAttribute("download", filename);

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            message.success("File downloaded successfully.");
          } else {
            throw new Error("Invalid response from server: Expected a Blob");
          }
        } catch (error) {
          console.error("Error:", error);
          message.error("An error occurred. Please try again.");
        } finally {
          // setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };

  // 处理选项变化
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // 获取子组件的值
  const getTableHead = () => {
    const list = childRef.current.getValue();
    setColumns(list);
    const transformedList = list.map((item) => ({
      label: item.dataIndex,
      value: item.key,
    }));
    console.log("columns", columns);
    setOptions(transformedList);
    const transformedList2 = list.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };
  const handleFilterChange = (filters) => {
    console.log("Received filters:", filters);
    setFiltersData(filters);
  };
  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    console.log("页面加载时执行");
    getTableHead();
  }, []); // 依赖数组为空，确保只在组件首次加载时执行
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start" >
        <div className="topLeft">
          {commonFn.btnAuthorityFlag('New') && <Space size="large">
            <Link target="_blank" to="/JobRequests/Maintenance/NewOrder">
              <Button className="btnNew" onClick={showModal}>
           <PlusOutlined />
                New
              </Button>
            </Link>
          </Space> || null}
          {commonFn.btnAuthorityFlag('Delete') && <Button className="btnDEL" variant="solid" onClick={confirm}>
        
            Delete
            <span className="num">{delList.length ? delList.length : 0}</span>
          </Button> || null}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c" onClick={toEcexl}>
              {/* <Popover content={content2} title="" trigger="click"> */}
              <VerticalAlignBottomOutlined />
              <CaretDownOutlined className="ft12" />
              {/* </Popover> */}
            </Radio.Button> || null}
          </Radio.Group>
        </div>
      </Flex>
      <MainTable
        ref={childRef}
        deleteNum={deleteNum}
        onFilterChange={handleFilterChange}
      ></MainTable>
    </div>
  );
}
